import axios from "@lib/axios";
import fetchServerSide from "@utils/fetchServerSide";

export async function getFaqCategories(locale) {
  const res = await fetchServerSide("/help/faq/categories", locale);

  return res.data;
}

export async function getFaqCategory(categorySlug) {
  const res = await fetchServerSide(`/help/faq/categories/${categorySlug}`);

  return res.data;
}

export async function getFaqArticles(locale) {
  const res = await fetchServerSide("/help/faq", locale);

  return res.data;
}

export async function getFaqFeaturedArticles(locale) {
  const res = await fetchServerSide("/help/faq/featured", locale);

  return res.data;
}

export async function getSupportFeaturedQuestions(locale) {
  const res = await fetchServerSide("/help/support/featured", locale);

  return res.data;
}

export async function getSupportCategories(locale) {
  const res = await fetchServerSide("/help/support/categories", locale);

  return res.data;
}

export async function getSupportQuestions(locale) {
  const res = await fetchServerSide("/help/support", locale);

  return res.data;
}

export async function getSupportQuestion(slug, locale) {
  const res = await fetchServerSide(`/help/support/${slug}`, locale);

  return res.data;
}

export async function postTicket(email, body, files, emailSubject = null, externalResources = []) {
  const formData = new FormData();
  formData.append("ticket[email]", email);
  formData.append("ticket[body]", body);
  if (emailSubject) formData.append("ticket[subject]", emailSubject);
  files.forEach((file) => formData.append("ticket[files][]", file));
  externalResources.forEach((resource) =>
    formData.append("ticket[external_resources][][type]", resource.type),
  );
  externalResources.forEach((resource) =>
    formData.append("ticket[external_resources][][id]", resource.id),
  );

  await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/help/tickets`, formData);
}
